import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { HardHat, ChevronRight } from "lucide-react";

export default function Projects() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/projects").then((r) => setItems(r.data || []));
  }, []);

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
      <header className="mb-8">
        <div className="text-xs font-mono uppercase tracking-widest text-[#b45309]">Works</div>
        <h1 className="mt-1 font-serif text-4xl font-semibold text-stone-900 sm:text-5xl">Building Projects</h1>
        <p className="mt-2 text-stone-600">Current and planned works for the building.</p>
      </header>

      {items.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-stone-300 bg-white p-10 text-center text-stone-600">
          <HardHat className="mx-auto mb-3 h-8 w-8 text-stone-400" />
          No building projects yet.
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {items.map((p, i) => (
            <Link
              key={p.id}
              to={`/projects/${p.id}`}
              data-testid={`project-card-${i}`}
              className="group overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-sm transition hover:shadow-lg"
            >
              {(() => {
                const firstImg = (p.attachments || []).find((a) =>
                  (a.content_type || "").startsWith("image/"),
                );
                return firstImg ? (
                  <img src={fileUrl(firstImg.file_id)} alt="" className="h-44 w-full object-cover" />
                ) : null;
              })()}
              <div className="p-6">
                <div className="text-xs font-mono uppercase tracking-widest text-[#b45309]">
                  {p.date ? new Date(p.date).toLocaleDateString("en-GB") : ""}
                </div>
                <h3 className="mt-2 font-serif text-2xl font-semibold text-stone-900 group-hover:text-[#b45309]">
                  {p.headline}
                </h3>
                <div className="mt-4 inline-flex items-center text-sm font-medium text-[#b45309]">
                  View project <ChevronRight className="ml-1 h-4 w-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
